import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { RootState } from "./store";

type BaseQuery = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>;

export const createBaseQuery =
  (baseUrl: string): BaseQuery =>
  async (args, api, extraOptions) => {
    return fetchBaseQuery({
      baseUrl: baseUrl,
      prepareHeaders: (headers, { getState }) => {
        const { auth } = getState() as RootState;
        if (auth.accessToken)
          headers.set("Authorization", `Bearer ${auth.accessToken}`);
      },
    })(args, api, extraOptions);
  };
